import { SvgIconComponent } from "@mui/icons-material";
import {
  Route,
  NoCrash,
  ReceiptLong,
  Task,
  CreditScore,
  TableRows,
  TableChart,
  Settings,
  ManageAccounts,
  Description,
  Inventory,
  FormatBold,
  Domain,
  Title,
  LocalShipping,
  RvHookup,
  PeopleAlt,
  Public,
} from "@mui/icons-material";
import PATH from "../../paths";

export type MenuRole = "admin" | "adminOrManager"; // undefined = everyone

export interface MenuLeaf {
  kind: "leaf";
  label: string;
  icon: SvgIconComponent;
  path: string; // PATH.* — used for navigate() and active-route match
  role?: MenuRole; // gate; omitted = always visible
}

export interface MenuGroup {
  kind: "group";
  label: string;
  icon: SvgIconComponent;
  role?: MenuRole; // group hidden entirely if the gate fails
  children: MenuLeaf[];
}

export type MenuNode = MenuLeaf | MenuGroup;

// Deconectare (logout) is intentionally NOT part of this config: it dispatches
// logout() rather than navigating, so each renderer renders it explicitly.

export const topLevelItems: MenuLeaf[] = [
  { kind: "leaf", label: "Comenzi", icon: Route, path: PATH.TRIP.LIST },
  { kind: "leaf", label: "Operare", icon: NoCrash, path: PATH.CONFIRM_TRIP },
  {
    kind: "leaf",
    label: "Facturare",
    icon: ReceiptLong,
    path: PATH.SHIPPER_INVOICE,
  },
  {
    kind: "leaf",
    label: "Validare documente",
    icon: Task,
    path: PATH.VALIDATE_TRIP_PUBLIC_UPLOADED_FILES,
  },
  {
    kind: "leaf",
    label: "Facturi scadente",
    icon: CreditScore,
    path: PATH.DUE_INVOICES,
  },
];

export const reportsGroup: MenuGroup = {
  kind: "group",
  label: "Raportare",
  icon: TableRows,
  children: [
    {
      kind: "leaf",
      label: "Comenzi/Beneficiari",
      icon: TableChart,
      path: PATH.REPORTS.TRIPS_SHIPPERS,
    },
    {
      kind: "leaf",
      label: "Comenzi/Dispeceri",
      icon: TableChart,
      path: PATH.REPORTS.TRIPS_DISPATCHERS,
    },
    {
      kind: "leaf",
      label: "Comenzi în pierdere",
      icon: TableChart,
      path: PATH.REPORTS.LOSER_TRIPS,
      role: "admin",
    },
    {
      kind: "leaf",
      label: "Comenzi profit < 100",
      icon: TableChart,
      path: PATH.REPORTS.PROFIT_LESS_THAN_ONE_HUNDRED,
      role: "admin",
    },
    {
      kind: "leaf",
      label: "Top clienți",
      icon: TableChart,
      path: PATH.REPORTS.TOP_CLIENTS,
      role: "admin",
    },
  ],
};

export const managementGroup: MenuGroup = {
  kind: "group",
  label: "Administrare",
  icon: Settings,
  children: [
    {
      kind: "leaf",
      label: "Utilizatori",
      icon: ManageAccounts,
      path: PATH.USERS,
      role: "adminOrManager",
    },
    {
      kind: "leaf",
      label: "Serii facturare",
      icon: Description,
      path: PATH.INVOICE_SERIES,
      role: "adminOrManager",
    },
    {
      kind: "leaf",
      label: "Tipuri de marfă",
      icon: Inventory,
      path: PATH.CARGO_TYPES,
    },
    { kind: "leaf", label: "Beneficiari", icon: FormatBold, path: PATH.SHIPPERS },
    {
      kind: "leaf",
      label: "Puncte de lucru",
      icon: Domain,
      path: PATH.SHIPPER_BRANCHES,
    },
    { kind: "leaf", label: "Transportatori", icon: Title, path: PATH.CARRIERS },
    {
      kind: "leaf",
      label: "Mașini",
      icon: LocalShipping,
      path: PATH.CARRIER_CARS,
    },
    { kind: "leaf", label: "Remorci", icon: RvHookup, path: PATH.CARRIER_TRAILERS },
    {
      kind: "leaf",
      label: "Șoferi",
      icon: PeopleAlt,
      path: PATH.CARRIER_DRIVERS,
    },
    { kind: "leaf", label: "Țări", icon: Public, path: PATH.COUNTRIES },
  ],
};

// isShipperBeneficiary sees only "Comenzi" (+ Deconectare handled separately).
export const shipperBeneficiaryItems: MenuLeaf[] = [
  { kind: "leaf", label: "Comenzi", icon: Route, path: PATH.TRIP.LIST },
];

export const isVisible = (
  role: MenuRole | undefined,
  isAdmin: boolean,
  isAdminOrManager: boolean
): boolean =>
  !role || (role === "admin" ? Boolean(isAdmin) : Boolean(isAdminOrManager));
